import axios from 'axios';

// Créer une instance Axios avec la configuration par défaut
const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://api.rh.qualisan972.fr',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Fonction pour vérifier si une URL est locale
const isLocalUrl = (url) => {
  if (!url) return false;
  return url.includes('localhost') || 
         url.includes('127.0.0.1') || 
         url.match(/^http:\/\/\d+\.\d+\.\d+\.\d+/) || // Adresses IP
         url.includes('host.docker.internal');
};

// Intercepteur pour s'assurer que toutes les URL utilisent HTTPS en production uniquement
instance.interceptors.request.use(config => {
  // Vérifier si nous sommes en développement
  const isDevelopment = import.meta.env.DEV === true || 
                        import.meta.env.MODE === 'development';
  
  // Si nous sommes en développement ou si l'URL est locale, ne pas transformer en HTTPS
  if (isDevelopment || isLocalUrl(config.url) || isLocalUrl(config.baseURL)) {
    return config;
  }
  
  // Sinon, pour la production, transformer HTTP en HTTPS
  if (config.url && config.url.startsWith('http://')) {
    config.url = config.url.replace(/^http:\/\//, 'https://');
  }
  
  if (config.baseURL && config.baseURL.startsWith('http://')) {
    config.baseURL = config.baseURL.replace(/^http:\/\//, 'https://');
  }
  
  return config;
});

export default instance;
